/* Signature Faucets - customer file upload for sf-form.
   Config comes from data-* attributes on [data-sf-file]; nothing here is Liquid.

   ⛔⛔ THE UPLOAD RUNS WHEN THE FILE IS CHOSEN, NOT ON SUBMIT. Do not "simplify"
   it back. Uploading on submit races the page navigation: something on the page
   submits the form regardless of preventDefault, the browser cancels the
   in-flight request (DevTools shows status "(unknown)") and Drive is left with a
   FOLDER BUT NO FILE. Confirmed 2026-07-30 in preview AND 2026-07-31 published.

   ⭐ While an upload runs the SUBMIT BUTTON IS DISABLED rather than the submit
   event being intercepted - there is nothing to fight that way.

   ⭐ ONE FOLDER PER VISIT, FILES ACCUMULATE. Later picks reuse the folder id and
   ADD to it. Removing deletes just that one file, never the whole folder.

   ⭐ The PUT uses XMLHttpRequest, not fetch, purely because XHR exposes
   upload.onprogress and fetch does not. That is what drives the progress bar. */
(function () {
  var MB = 1048576;
  var TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/webp',
               'video/mp4', 'video/quicktime'];

  function human(n) {
    return n < MB ? (Math.max(1, Math.round(n / 1024)) + 'KB') : (Math.round(n / MB) + 'MB');
  }

  /* Phones do not drag and drop, so the wording changes rather than promising
     something the device cannot do. */
  function supportsDrag() {
    return !('ontouchstart' in window) && 'draggable' in document.createElement('div');
  }

  function init(wrap) {
    var form = wrap.closest ? wrap.closest('form') : null;
    if (!form || wrap.getAttribute('data-sf-ready')) return;
    var EP = wrap.getAttribute('data-endpoint') || '';
    var KEY = wrap.getAttribute('data-key') || '';
    if (!EP || !KEY) return;
    wrap.setAttribute('data-sf-ready', '1');

    var input = wrap.querySelector('input[type=file]');
    var list = wrap.querySelector('[data-sf-filelist]');
    var err = wrap.querySelector('[data-sf-fileerr]');
    var note = wrap.querySelector('[data-sf-filestatus]');
    var hidden = form.querySelector('[data-sf-attach]');
    var button = form.querySelector('[type=submit]');
    if (!input || !hidden) return;

    /* Drop zone. Built here, not in Liquid, and the plain input is only hidden
       once this succeeds (.is-enhanced) - if the script never runs the customer
       still gets the ordinary Choose Files control rather than nothing.
       The browse control is a LABEL bound to the input, so the picker opens
       natively with no JS click-forwarding, and it carries the theme's own
       `button` class so it inherits button styling and future theme changes. */
    var drop = document.createElement('div');
    drop.className = 'sf-form__drop';
    drop.setAttribute('data-sf-drop', '');
    drop.innerHTML =
      '<svg class="sf-form__dropicon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 16V4"/><path d="m7 9 5-5 5 5"/>' +
      '<path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/></svg>' +
      '<p class="sf-form__droptext"></p>';
    drop.querySelector('.sf-form__droptext').textContent = supportsDrag()
      ? 'Drag photos or video here'
      : 'Add photos or video of the issue';

    var browse = document.createElement('label');
    browse.className = 'button button--sm';
    browse.setAttribute('for', input.id);
    browse.textContent = 'Browse files';
    drop.appendChild(browse);

    input.parentNode.insertBefore(drop, input.nextSibling);
    wrap.classList.add('is-enhanced');

    /* The progress bar is built here too, so UI additions never require
       rewriting the 25KB Liquid section again. */
    var bar = document.createElement('p');
    bar.className = 'sf-form__progress';
    bar.hidden = true;
    var fill = document.createElement('span');
    fill.className = 'sf-form__progressfill';
    bar.appendChild(fill);
    if (list && list.parentNode) list.parentNode.insertBefore(bar, list.nextSibling);
    else wrap.appendChild(bar);

    var FORMNAME = wrap.getAttribute('data-form-name') || 'Form';
    var MAXF = parseInt(wrap.getAttribute('data-max-files'), 10) || 5;
    var MAXIMG = (parseInt(wrap.getAttribute('data-max-photo'), 10) || 10) * MB;
    var MAXVID = (parseInt(wrap.getAttribute('data-max-video'), 10) || 300) * MB;
    var MAXTOT = (parseInt(wrap.getAttribute('data-max-total'), 10) || 350) * MB;

    var folderId = '';
    var folderUrl = '';
    var attached = [];
    var busy = false;
    var buttonLabel = button ? button.innerHTML : '';

    function showErr(m) { err.textContent = m; err.hidden = false; }
    function clearErr() { err.textContent = ''; err.hidden = true; }

    function say(msg, state) {
      note.textContent = msg;
      note.className = 'sf-form__filestatus' + (state ? ' is-' + state : '');
    }

    function ready() {
      return attached.length > 1
        ? 'All ' + attached.length + ' attached. You can send the form now.'
        : 'Attached. You can send the form now.';
    }

    function progress(pct) {
      bar.hidden = pct === null;
      fill.style.width = (pct === null ? 0 : pct) + '%';
    }

    function lock(on) {
      busy = on;
      if (!button) return;
      button.disabled = on;
      button.innerHTML = on ? 'Uploading...' : buttonLabel;
    }

    function render() {
      list.innerHTML = '';
      attached.forEach(function (f, i) {
        var row = document.createElement('span');
        row.className = 'sf-form__fileitem';
        row.appendChild(document.createTextNode(f.name + ' (' + human(f.size) + ') '));
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'sf-form__fileremove';
        x.setAttribute('aria-label', 'Remove ' + f.name);
        x.textContent = 'remove';
        x.addEventListener('click', function () { remove(i); });
        row.appendChild(x);
        list.appendChild(row);
      });
    }

    /* Delete just this ONE file in Drive. It must not disturb the others - the
       first version emptied the folder and re-uploaded the survivors, which
       re-sent files that were already safely stored. On a 300MB video that is a
       long wait for nothing (Noam caught this, 2026-07-31).
       `gone.name` is the name AFTER compression, i.e. what Drive actually holds. */
    function remove(index) {
      if (busy) return;
      var gone = attached[index];
      if (!gone) return;
      attached.splice(index, 1);
      render();
      hidden.value = attached.length ? folderUrl : '';
      if (!attached.length) say('', null);
      if (!folderId) return;

      fetch(EP, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          token: KEY, action: 'removeFile', folderId: folderId,
          name: gone.name, origin: window.location.origin
        })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok) throw new Error((d && d.error) || 'refused');
        if (attached.length) say(ready(), 'ok');
      })["catch"](function (e) {
        console.error('sf-form remove failed:', e);
        say('Removed from the form, but we could not delete it on our side.', 'bad');
      });
    }

    /* One path for both the picker and drag-and-drop. */
    function accept(picked) {
      if (busy || !picked.length) return;
      var bytes = attached.reduce(function (s, a) { return s + a.size; }, 0);
      var msg = validate(picked, attached.length, bytes);
      if (msg) { showErr(msg); return; }
      clearErr();
      lock(true);
      progress(0);
      say('Preparing...', null);
      Promise.all(picked.map(compress)).then(upload).then(done)["catch"](failed);
    }

    function validate(files, existingCount, existingBytes) {
      if (existingCount + files.length > MAXF) return 'Please keep it to ' + MAXF + ' files in total.';
      var total = existingBytes;
      for (var i = 0; i < files.length; i++) {
        var f = files[i], t = (f.type || '').toLowerCase();
        if (TYPES.indexOf(t) === -1) return '"' + f.name + '" is not a photo or video we can accept.';
        var isVid = t.indexOf('video/') === 0, cap = isVid ? MAXVID : MAXIMG;
        if (f.size > cap) {
          return isVid
            ? '"' + f.name + '" is ' + human(f.size) + '. Videos need to be under ' + human(cap) + ' - a shorter clip works fine.'
            : '"' + f.name + '" is ' + human(f.size) + '. Photos need to be under ' + human(cap) + '.';
        }
        total += f.size;
      }
      if (total > MAXTOT) return 'That is ' + human(total) + ' in total. Please keep it under ' + human(MAXTOT) + '.';
      return '';
    }

    /* Shrink photos in the browser. Any failure returns the original - HEIC cannot
       be decoded by canvas everywhere, and a claim must never be blocked by this. */
    function compress(file) {
      if (!/^image\//.test(file.type || '') || !window.createImageBitmap) return Promise.resolve(file);
      return createImageBitmap(file).then(function (bmp) {
        var big = Math.max(bmp.width, bmp.height);
        if (big <= 2000 && file.size < 1500000) return file;
        var s = Math.min(1, 2000 / big), c = document.createElement('canvas');
        c.width = Math.round(bmp.width * s);
        c.height = Math.round(bmp.height * s);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        return new Promise(function (res) {
          c.toBlob(function (b) {
            if (!b || b.size >= file.size) return res(file);
            res(new File([b], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.82);
        });
      })["catch"](function () { return file; });
    }

    function orderNumber() {
      var el = form.querySelector('[name="contact[order_number]"]');
      return el ? el.value : '';
    }

    /* XHR rather than fetch: only XHR reports upload progress. */
    function put(url, file, onPct) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) onPct(e.loaded / e.total);
        };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) resolve();
          else reject(new Error('upload rejected (' + xhr.status + ')'));
        };
        xhr.onerror = function () { reject(new Error('network error')); };
        xhr.send(file);
      });
    }

    function upload(files) {
      var meta = files.map(function (f) { return { name: f.name, mimeType: f.type, size: f.size }; });
      var payload = {
        token: KEY, formName: FORMNAME, orderNumber: orderNumber(),
        origin: window.location.origin, files: meta
      };
      if (folderId) payload.folderId = folderId;
      /* text/plain keeps this a simple request, so no CORS preflight. */
      return fetch(EP, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (!data || !data.ok) throw new Error((data && data.error) || 'refused');
        folderId = data.folderId || folderId;
        folderUrl = data.folderUrl || folderUrl;
        var totalBytes = files.reduce(function (s, f) { return s + f.size; }, 0) || 1;
        var sentBytes = 0;
        var chain = Promise.resolve();
        files.forEach(function (f, i) {
          chain = chain.then(function () {
            say(files.length > 1 ? 'Uploading ' + (i + 1) + ' of ' + files.length + '...' : 'Uploading...', null);
            return put(data.uploads[i].uploadUrl, f, function (frac) {
              progress(Math.round(((sentBytes + f.size * frac) / totalBytes) * 100));
            }).then(function () { sentBytes += f.size; });
          });
        });
        return chain.then(function () { return files; });
      });
    }

    function done(files) {
      files.forEach(function (f) {
        attached.push({ name: f.name, size: f.size, file: f });
      });
      hidden.value = folderUrl;
      progress(null);
      render();
      say(ready(), 'ok');
      lock(false);
    }

    function failed(e) {
      console.error('sf-form upload failed:', e);
      progress(null);
      render();
      hidden.value = 'Upload failed (' + ((e && e.message) || 'unknown') + ') - customer has photos or video to send.';
      say('We could not attach your files, but you can still send the form and we will ask for them.', 'bad');
      lock(false);
    }

    if (supportsDrag()) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        drop.addEventListener(evt, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      drop.addEventListener('dragleave', function (e) {
        if (drop.contains(e.relatedTarget)) return;
        drop.classList.remove('is-over');
      });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        drop.classList.remove('is-over');
        var dropped = e.dataTransfer && e.dataTransfer.files;
        if (dropped && dropped.length) accept(Array.prototype.slice.call(dropped));
      });
    }

    input.addEventListener('change', function () {
      var picked = Array.prototype.slice.call(input.files);
      input.value = '';                       // let them pick the same file again later
      accept(picked);
    });

    /* Backstop only. The disabled button is the real guard; this catches a
       programmatic submit fired while an upload is still running. */
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); say('Still uploading, one moment...', null); }
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-sf-file]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
